// https://developers.google.com/analytics/devguides/collection/gtagjs/pages
export const GApageview = (url: string, gtagId: string) => {
  (window as any).gtag('config', gtagId, {
    page_path: url,
  });
};
